import { emitChatNotification } from "../notification-center/chatNotificationBus";

export interface MessageGroupToastPayload {
  uid: string;
  groupUid: string;
  groupName: string;
  senderName: string;
  companyId?: number | string | null;
  companyName?: string | null;
  text: string;
  mentionsMe?: boolean;
  channel?: "internal" | "sms";
}

export const emitMessageGroupToast = (payload: MessageGroupToastPayload): void => {
  if (!payload.groupUid) return;

  emitChatNotification({
    id: payload.uid,
    kind: payload.channel === "sms" ? "group-sms" : "group",
    companyId: payload.companyId ?? null,
    companyName: payload.companyName ?? null,
    title: payload.mentionsMe ? `${payload.groupName} · mentioned you` : payload.groupName,
    body: payload.senderName ? `${payload.senderName}: ${payload.text}` : payload.text,
    chatName: payload.groupName,
    focusMessageUid: payload.uid,
    focusMessageText: payload.text,
    target: {
      type: "group",
      groupUid: payload.groupUid,
      companyId: payload.companyId ?? null,
    },
  });
};
